import React, { useEffect, useState } from 'react';
import './_finariumBalanceCard.less';
import { AED, Asset, Bitcoin, Ethereum, EUR, GBP, JPY, List, MUR, UnifyLogo, USD, USDC, USDT } from 'IMAGE';
import PropTypes from 'prop-types';
import Spinner from '@atoms/spinner';
import { Modal } from 'antd';

const UnifyBalanceCard = ({ balanceUnify }) => {
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [destroyOnClose, setDestroyOnClose] = useState(true);

  useEffect(() => {
    if (balanceUnify) {
      const count = Object.keys(balanceUnify).length;
      setShowModal(count > 4);
    }
  }, [balanceUnify]);

  const isLoaded = !balanceUnify;

  const iconArray = [
    { code: 'USD', name: 'INVEST ACCOUNT', icon: USD },
    { code: 'USDT', icon: USDT },
    { code: 'USDC', icon: USDC },
    { code: 'BTC', name: 'BITCOIN', icon: Bitcoin },
    { code: 'ETH', name: 'ETHEREUM', icon: Ethereum },
    { code: 'EUR', icon: EUR },
    { code: 'JPY', icon: JPY },
    { code: 'AED', icon: AED },
    { code: 'GBP', icon: GBP },
    { code: 'MUR', icon: MUR },
    { code: 'AAPL', icon: Asset },
    { code: 'GOOG', icon: Asset },
  ];

  const toggleModal = (visible = !visible, destroyOnClose = true) => {
    setVisible(visible);
    setDestroyOnClose(destroyOnClose);
  };

  const formatNumber = (value) => {
    if (value.currency_type === 'CRYPTO') {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
      }).format(value.balance || 0);
    }

    if (value.currency_type === 'ASSET') {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
      }).format(value.balance || 0);
    }
    const amount = Number(value.balance).toFixed(2);
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  const modalTitle = (
    <div className='crypto-card-modal__header'>
      <div className='crypto-card-modal__brand'>
        <UnifyLogo width={40} height={40} />
        <div className='crypto-card-modal__brand-text'>
          <div className='crypto-card-modal__brand-title'>Lava</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='crypto-card'>
      <div className='crypto-card__header'>
        <div className='crypto-card__brand'>
          <UnifyLogo width={40} height={40} />
          <div className='crypto-card__brand-text'>
            <div className='crypto-card__brand-title'>Lava</div>
          </div>
        </div>
        {/*<div className='icon-chevron' />*/}
      </div>

      {balanceUnify && (
        <div className='crypto-card__main'>
          <ul className='crypto-card__list'>
            {Object.entries(balanceUnify).map(([key, value]) => {
              const iconItem = iconArray.find((item) => item.code === key);
              const IconComponent = iconItem ? iconItem.icon : Asset;
              const name = iconItem ? iconItem.name : null;

              return (
                <>
                  {value?.approximate_fiat_equivalent && (
                    <li key={key} className='crypto-card__row-equivalent'>
                      <div className='crypto-card__left'>
                        {IconComponent && <IconComponent width={14} height={14} />}
                        <span className='crypto-card__ccy'>{key}</span>
                      </div>
                      <div className='crypto-card__amount'>
                        <div className='amount-current'>{formatNumber(value)}</div>
                        <div className='amount-fiat'>≈ ${value?.approximate_fiat_equivalent?.balance}</div>
                      </div>
                    </li>
                  )}

                  {!value?.approximate_fiat_equivalent && (
                    <li key={key} className='crypto-card__row'>
                      <div className='crypto-card__left'>
                        {IconComponent && <IconComponent width={14} height={14} />}
                        <span className='crypto-card__ccy'>{key}</span>
                      </div>
                      {/*<div className='crypto-card__right'>*/}
                      <div className='crypto-card__amount'>
                        {/*{getSymbolFromCurrency(key)}*/}
                        {formatNumber(value)}
                      </div>
                    </li>
                  )}
                </>
              );
            })}
          </ul>
        </div>
      )}

      {Array.isArray(balanceUnify) && balanceUnify.length === 0 && (
        <div className='fiat-card__main'>
          <div>To activate the wallet, please contact your personal manager.</div>
        </div>
      )}

      {showModal && (
        <div className='crypto-card__modal-label' onClick={() => toggleModal(true)}>
          <List /> <span className='text'>ALL CURRENCIES</span>
        </div>
      )}

      <Modal
        visible={visible}
        destroyOnClose={destroyOnClose}
        maskClosable={true}
        title={modalTitle}
        footer={null}
        onCancel={() => toggleModal(false)}
      >
        <div className='crypto-card-modal'>
          {balanceUnify && (
            <div className='crypto-card__main'>
              <ul className='crypto-card__list'>
                {Object.entries(balanceUnify).map(([key, value]) => {
                  const IconComponent = iconArray.find((item) => item.code === key)?.icon || Asset;
                  return (
                    <>
                      {value?.approximate_fiat_equivalent && (
                        <li key={key} className='crypto-card__row-equivalent'>
                          <div className='crypto-card__left'>
                            {IconComponent && <IconComponent width={14} height={14} />}
                            <span className='crypto-card__ccy'>{key}</span>
                          </div>
                          <div className='crypto-card__amount'>
                            <div className='amount-current'>{formatNumber(value)}</div>
                            <div className='amount-fiat'>≈ ${value?.approximate_fiat_equivalent?.balance}</div>
                          </div>
                        </li>
                      )}

                      {!value?.approximate_fiat_equivalent && (
                        <li key={key} className='crypto-card__row'>
                          <div className='crypto-card__left'>
                            {IconComponent && <IconComponent width={14} height={14} />}
                            <span className='crypto-card__ccy'>{key}</span>
                          </div>
                          {/*<div className='crypto-card__right'>*/}
                          <div className='crypto-card__amount'>
                            {/*{getSymbolFromCurrency(key)}*/}
                            {formatNumber(value)}
                          </div>
                        </li>
                      )}
                    </>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </Modal>

      {isLoaded && <Spinner />}
    </div>
  );
};

export default UnifyBalanceCard;
UnifyBalanceCard.propTypes = {
  balanceUnify: PropTypes.object,
};
